import React from "react";

type RequiredLabelProps = {
    text: string;
    required?: boolean;
};

const RequiredLabel: React.FC<RequiredLabelProps> = ({ text, required = false }) => (
    <label className='f-label'>
        {text} {required && <span style={{ color: "red" }}>*</span>}
    </label>
);

export default RequiredLabel;
